import { render, staticRenderFns } from "./TabHomestays.vue?vue&type=template&id=ff8e20a8&scoped=true&"
import script from "./TabHomestays.vue?vue&type=script&lang=js&"
export * from "./TabHomestays.vue?vue&type=script&lang=js&"
import style0 from "./TabHomestays.vue?vue&type=style&index=0&id=ff8e20a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8e20a8",
  null
  
)

export default component.exports